import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NativeTable from '../../../../components/NativeTable/NativeTable';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Loader from '../../../../components/Loader/Loader';
import { createPicture, updatePicture, deletePicture } from '../../../../actions/settings';
import { IMAGE_PRESETS, processImageFileInput, revokeImagePreviewUrl } from '../../../../utils/imageUtils';
import { toast } from 'react-toastify';

import screen from '../CustomerScreen.module.scss';
import { withTranslation } from '../../../../i18n/LanguageContext';

class Pictures extends React.Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        pictures: []
    };

    state = {
        isAddModal: false,
        deleteAssetId: null,
        picName: "",
        curPicture: null,
        picError: "",
        picFile: null,
        tempPicture: "",
        editError: ""
    };

    constructor() {
        super();

        this.changeName = this.changeName.bind(this);
        this.changePicture = this.changePicture.bind(this);
        this.changeEditPictureName = this.changeEditPictureName.bind(this);
        this.apiFormatter = this.apiFormatter.bind(this);
    }

    changeName(event) {
        this.setState({ picName: event.target.value, picError: "" });
    }

    changeEditPictureName(event) {
        var curPicture = this.state.curPicture;
        curPicture.Name = event.target.value;
        this.setState({ curPicture: curPicture, editError: "" });

        this.setState({ stationName: event.target.value, stationError: "" });
    }

    async changePicture(event) {
        const input = event.target;
        const file = input.files && input.files[0];

        if (!file) {
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "" });
            return;
        }

        try {
            const result = await processImageFileInput(
                file,
                this.state.tempPicture,
                IMAGE_PRESETS.product
            );
            this.setState({
                tempPicture: result.previewUrl,
                picFile: result.file,
            });
        } catch (error) {
            console.error('[Pictures] changePicture failed', error);
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "" });
            toast.error(error.message || 'Could not use that photo. Try again with a smaller image.');
        } finally {
            input.value = '';
        }
    }

    onClickSavePicture = (e) => {
        e.preventDefault();

        var picError = "";
        const {picName, picFile} = this.state;

        if (picName == "") {
            picError = "Please input name";
        } else if (picFile == null) {
            picError = "Please choose an image file";
        }

        if (picError == "") {
            this.props.dispatch(createPicture({
                picFile,
                picName
            }))
        }
        this.setState({picError: picError});
    }

    onClickUpdate = (event) => {
        event.preventDefault();

        const { curPicture } = this.state;

        var editError = "";
        if (curPicture.Name == "") {
            editError = "Please input the picture name";
        }

        if (editError == "") {
            this.props.dispatch(updatePicture(curPicture));
            this.setState({isAddModal: false});
        } else {
            this.setState({editError: editError});
        }
    }

    editPicture (assetId) {
        const picture = this.getPictureById(assetId);
        this.setState({isAddModal: true, curPicture: picture});
    }

    getPictureById = (id) => {
        const { pictures } = this.props;
        var data = pictures.filter(function( p ) {
            return p.AssetId == id;
        });

        var picture = null;
        if (data.length > 0) {
            picture = {... data[0]};
        }
        return picture;
    }

    removePicture(id) {
        this.closeDeleteModal();
        this.props.dispatch(deletePicture(id));
    }

    closeEditModal = () => {
        this.setState({isAddModal: false, editError: ""});
    }

    openDeleteModal = (assetId) => {
        this.setState({ deleteAssetId: assetId });
    }

    closeDeleteModal = () => {
        this.setState({ deleteAssetId: null });
    }

    apiFormatter(cell, row) {
        return (
            <div className={screen.cardActions}>
                <button
                    type="button"
                    className={screen.secondaryBtn}
                    onClick={() => this.editPicture(row.AssetId)}
                >
                    {this.props.t('common.edit')}
                </button>
                <button
                    type="button"
                    className={screen.dangerBtn}
                    onClick={() => this.openDeleteModal(row.AssetId)}
                    disabled={this.props.isDeleting && this.props.idToDelete === row.AssetId}
                >
                    {this.props.isDeleting && this.props.idToDelete === row.AssetId ? <Loader size={14}/> : this.props.t('common.delete')}
                </button>
            </div>
        );
    }

    imageFormatter(cell) {
        if (cell == "" || cell == null ) {
            return (<div></div>);
        }
        return (
            <img src={cell} alt="" className={screen.thumb} />
        );
    }

    render() {
        const { t } = this.props;
        const {curPicture, picError, tempPicture, picName, editError, isAddModal, deleteAssetId} = this.state;
        const { pictures } = this.props;
        const deletePictureRow = deleteAssetId != null ? this.getPictureById(deleteAssetId) : null;

        return (
            <div className={screen.sectionCard}>
                <div className={screen.sectionCardHeader}>{t('customerScreen.images')}</div>
                <div className={screen.sectionCardBody}>
                    <p className={screen.noteText}>{t('customerScreen.imagesIntro')}</p>
                    <form onSubmit={this.onClickSavePicture}>
                        <label className={screen.uploadDrop}>
                            <input type="file" onChange={this.changePicture} accept="image/*"/>
                            <i className="zmdi zmdi-image-alt"></i>
                            <span>{tempPicture ? t('customerScreen.replaceImage') : t('customerScreen.chooseImage')}</span>
                        </label>
                        {tempPicture ? (
                            <img src={tempPicture} alt="" className={screen.preview} />
                        ) : null}
                        <div className={screen.field}>
                            <label htmlFor="customer-screen-image-name">{t('customerScreen.imageName')}</label>
                            <input
                                id="customer-screen-image-name"
                                type="text"
                                className="form-control"
                                value={picName}
                                onChange={this.changeName}
                            />
                        </div>
                        {picError ? (
                            <Alert className="alert-sm" color="danger">{picError}</Alert>
                        ) : null}
                        <button type="submit" className={screen.primaryBtn}>{t('customerScreen.saveImage')}</button>
                    </form>
                    <div className={screen.tableWrap}>
                        <NativeTable
                            data={pictures}
                            columns={[
                                { key: 'Thumbnail', header: t('common.image'), render: (cell) => this.imageFormatter(cell) },
                                { key: 'Name', header: t('common.name') },
                                { key: 'AssetId', header: '', render: (cell, row) => this.apiFormatter(cell, row) },
                            ]}
                        />
                    </div>
                </div>
                <Modal isOpen={isAddModal} toggle={this.closeEditModal} modalClassName={screen.darkModal}>
                    <ModalHeader toggle={this.closeEditModal}>{t('customerScreen.editImageName')}</ModalHeader>
                    <ModalBody>
                        {editError ? (
                            <Alert className="alert-sm" color="danger">{editError}</Alert>
                        ) : null}
                        {curPicture ? (
                            <div className={screen.field}>
                                <label htmlFor="customer-screen-edit-image-name">{t('customerScreen.imageName')}</label>
                                <input
                                    id="customer-screen-edit-image-name"
                                    type="text"
                                    className="form-control"
                                    value={curPicture.Name}
                                    onChange={this.changeEditPictureName}
                                />
                            </div>
                        ) : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" outline onClick={this.closeEditModal}>{t('common.cancel')}</Button>
                        <Button color="primary" onClick={this.onClickUpdate}>{t('common.update')}</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteAssetId != null} toggle={this.closeDeleteModal} modalClassName={screen.darkModal}>
                    <ModalHeader toggle={this.closeDeleteModal}>{t('customerScreen.deleteImage')}</ModalHeader>
                    <ModalBody>
                        {deletePictureRow
                            ? t('customerScreen.deleteImageNamed', { name: deletePictureRow.Name })
                            : t('customerScreen.deleteImageBody')}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" outline onClick={this.closeDeleteModal}>{t('common.cancel')}</Button>
                        <Button
                            color="danger"
                            onClick={() => this.removePicture(deleteAssetId)}
                            disabled={this.props.isDeleting}
                        >
                            {this.props.isDeleting ? <Loader size={14}/> : t('common.delete')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        pictures: state.settings.pictures,
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(Pictures)));
